import React, { useEffect } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import './AddSubUserCompleteModal.scss'
import Image from "components/Elements/Image/Image.tsx";

const AddSubUserCompleteModal = ({ typeOfModal = null }) => {

    const { getTextByKey } = useContent();

    return (
        <div className="add-sub-user-complete-modal-wrapper">
            <div className="logo">
                <Image name={"sub-user-complete-image"}>
                </Image>    
            </div>
            <div className="title">
                {getTextByKey("add-sub-user-complete-modal-title")}
            </div>
            <div className="text">
                {getTextByKey("add-sub-user-complete-modal-text")}
            </div>
            
        </div>
    )

}

export default AddSubUserCompleteModal;